import React from 'react';
import ResumeSection from 'src/components/Resume/resume-section';
import EducationResumeSection from 'src/components/Resume/education-resume-section';
import {View} from '@react-pdf/renderer';
import {StudentResume} from 'src/components/Resume/format-student-for-resume';
import {Course} from 'src/types/education';
import {CommunityServiceEvent} from 'src/types/store';

interface Props {
  studentInfo: StudentResume;
  blackAndWhite?: boolean;
}

const PrintResumeSections = ({studentInfo, blackAndWhite}: Props) => {
  const {currentInstitution, highSchoolInfo, communityCollegeInfo} = studentInfo;
  const sections = studentInfo.portfolio;

  // Choose which sections to be included in resume and give custom names.
  let formattedSections = [
    {
      name: 'Extracurriculars',
      activities: sections['activities'],
    },
    {
      name: 'Work Experience',
      activities: sections['workExperiences'],
    },
    {
      name: 'Community Service',
      activities: sections['communityServiceEvents'] as CommunityServiceEvent[],
    },
    {
      name: 'Honors and Awards',
      activities: sections['awards'],
    },
  ];

  // Remove sections that don't have any items.
  formattedSections = formattedSections.filter((section) => section.activities.length > 0);

  // Change course object to course name string.
  interface CollegeCourse {
    name: string;
    courseCode: string;
  }

  const courses: (Course | CollegeCourse)[] =
    sections.courses.length > 0 ? sections.courses : (sections.collegeCourses as CollegeCourse[]);
  const nonvisibleCourseTypes = ['Regular', 'Dual Enrollment', 'Certification'];
  const formattedCourses = courses.map((course) => {
    let courseName = course.name;

    if ('courseType' in course) {
      // HS student, add course type
      if (!nonvisibleCourseTypes.includes(course.courseType)) {
        courseName = course.courseType + ' ' + course.name;
      }
    } else {
      // CC student, add course code
      courseName = course.courseCode + ' - ' + course.name;
    }

    return courseName;
  });

  // Create list of ResumeSection elements.
  const sectionItems = formattedSections.map((section) => (
    <ResumeSection
      key={section.name}
      name={section.name}
      activities={section.activities}
      blackAndWhite={blackAndWhite}
    />
  ));

  return (
    <View>
      <EducationResumeSection
        school={currentInstitution.name}
        gradYear={
          currentInstitution.type === 'HighSchool'
            ? highSchoolInfo?.graduationYear
            : communityCollegeInfo?.transferYear
        }
        gpa={
          currentInstitution.type === 'HighSchool' ? highSchoolInfo?.gpa : communityCollegeInfo?.gpa
        }
        courses={formattedCourses}
        blackAndWhite={blackAndWhite}
      />
      {sectionItems}
    </View>
  );
};

export default PrintResumeSections;
